// **************************************************************************************

jQuery( document ).ready( electricSidebarsReady );

// **************************************************************************************

function electricSidebarsReady() {
	// Toggle mobile sidebar on button click.
	jQuery( '.sidebar-button' ).on( 'click', electricDoSidebarButtonClick );

}

// **************************************************************************************

// Toggle mobile sidebar.
function electricDoSidebarButtonClick() {

	jQuery( 'aside' ).toggleClass( 'visible' );

	var sidebar = jQuery( 'aside' )[0];
	sidebar = jQuery( sidebar );

	if ( sidebar.hasClass( 'visible' ) ) {
		var height = 0;
		sidebar.children().each( function () {
			height += jQuery( this ).outerHeight( true );
		} );
		sidebar.css( 'height', height );
	} else {
		sidebar.css( 'height', 60 );
	}

}
// **************************************************************************************
